import React from 'react'
import './ExperienceCard.css'
import { useTilt } from '../../hooks/useTilt'
import { useScrollZoom } from '../../hooks/useScrollZoom'

// A short, stable "commit hash" derived from the company name  not a real
// hash of anything meaningful, just a deterministic 7-char id so each job
// reads like an actual git-log entry instead of a generic list item.
const commitHash = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash |= 0
  }
  return (hash >>> 0).toString(16).padStart(7, '0').slice(0, 7)
}

const ExperienceCard = ({ experience }) => {
  let { link, title, info, stack, logoTitle, city } = experience
  const tiltRef = useTilt({ max: 4, scale: 1.01 })
  const zoomRef = useScrollZoom()

  return (
    <a
      className="commit-link"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      ref={zoomRef}
    >
      <div className="commit-row" ref={tiltRef}>
        <div className="commit-graph" aria-hidden="true">
          <span className="commit-graph-dot" />
        </div>
        <div
          className="commit-avatar"
          style={{
            background: experience.colourSecondary || experience.colourPrimary,
          }}
        >
          <img
            className="commit-avatar-logo"
            src={require(`../../images/logos/${logoTitle}`)}
            alt={`${title} logo`}
            style={
              experience.logoheight
                ? { height: `${experience.logoheight}%` }
                : { width: `${experience.logowidth}%` }
            }
          />
        </div>
        <div className="commit-content">
          <div className="commit-meta">
            <code className="commit-hash">{commitHash(title)}</code>
            {city && <span className="commit-city">{city}</span>}
          </div>
          <h3 className="commit-message">{title}</h3>
          <ul className="commit-body">
            {info.map((point, idx) => (
              <li key={`${title}-point-${idx}`}>{point}</li>
            ))}
          </ul>
          <ul className="commit-files">
            {stack.map((tech) => (
              <li key={`${title}-${tech}`}>{tech}</li>
            ))}
          </ul>
        </div>
      </div>
    </a>
  )
}

export default ExperienceCard
